









import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SelectedChannel, ChannelGroup } from '@/core/components/networkViewer/types';
import { Formatters } from '@/core/components/networkViewer/formatters';
import { LogisticsNetwork } from '@/dto/';
@Component
export default class SVGPolygon extends Vue {
    @Prop({ type: Object, required: true }) public network!: LogisticsNetwork;
    @Prop({ type: Object, required: true }) public item!: ChannelGroup;
    @Prop({ type: Boolean, required: true }) public calcClass!: boolean;
    @Prop({ type: Number, required: true }) public showPolygon!: number;
    @Prop({ type: String, required: true }) public polygon!: string;
    @Prop({ type: Object, required: false }) public selectedChannel!: SelectedChannel;

    private get defaultClass() {
        if (!this.calcClass) {
            return true;
        }
    }

    public selectChannel(item: any, value1: any, value2: any, event: any) {
        this.$emit('selectChannel', this.item, value1, value2, event);
    }

    private get show() {
        if (this.showPolygon === 0) {
            return false;
        } else if (this.showPolygon === 1) {
                    return true;
                } else if (this.showPolygon === 2) {
                            const result = Formatters.prototype.add(this.item.point1.flow ?? 0,
                                                                    this.item.point2.flow ?? 0);
                            return result > 0;
                        } else if (this.showPolygon === 3) {
                                    return this.selectedChannel.point.flow > 0;
                                }
    }

    private get calculateClass() {
        if (!this.defaultClass) {
            let result: any;
            if (this.showPolygon !== 3) {
                result = Formatters.prototype.or(this.item.point1.freezed, this.item.point2.freezed);
                result = Formatters.prototype.select(result, 'network-flow', 'network-flow', 'network-flow');
            } else {
                result = true;
            }

            return result;
        }

        return false;
    }
}
